import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import ImageUploader from '../components/ImageUploader';
import LoadingSpinner from '../components/LoadingSpinner';
import { useAppContext } from '../context/AppContext';
import { analyzeImageWithGroq } from '../services/groqService';
import { determineSizeFromMeasurements, validateMeasurements } from '../services/measurementService';

const HomeContainer = styled.div`
  max-width: 900px;
  margin: 0 auto;
  padding: 40px 20px;
`;

const Header = styled.header`
  text-align: center;
  margin-bottom: 40px;
  
  h1 {
    font-size: 2.5rem;
    color: #fff;
    margin-bottom: 10px;
  }
  
  p {
    color: #ff3;
    font-size: 1.1rem;
  }
`;

const HomePage = () => {
  const { 
    setUserImage,
    setMeasurements,
    setRecommendedSize,
    loading,
    setLoading
  } = useAppContext();
  
  const navigate = useNavigate();
  
  const handleImageSelected = async (imageData) => {
    try {
      console.log("Image selected, processing...");
      setUserImage(imageData);
      setLoading(true);
      
      // Extract the base64 portion of the data URL
      const base64Data = imageData.split(',')[1];
      
      // Call Groq API to analyze the image
      console.log("Calling Groq API...");
      const measurementsData = await analyzeImageWithGroq(base64Data);
      console.log("Measurements received:", measurementsData);
      
      // Validate the measurements
      const validation = validateMeasurements(measurementsData);
      console.log("Validation result:", validation);
      
      if (!validation.valid) {
        alert(validation.message);
        setLoading(false);
        return;
      }
      
      // Determine clothing size
      const size = determineSizeFromMeasurements(measurementsData);
      console.log("Recommended size:", size);
      
      // Update state
      console.log("Setting measurements in context:", measurementsData);
      setMeasurements(measurementsData);
      
      console.log("Setting recommended size in context:", size);
      setRecommendedSize(size);
      
      // Check if context was updated properly
      setTimeout(() => {
        console.log("About to navigate to /measurements");
        // Navigate to measurements page
        navigate('/measurements');
      }, 100);
      
    } catch (error) {
      console.error('Error processing image:', error);
      alert('Failed to process image. Please try again.');
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <HomeContainer>
      <Header>
        <h1>AI Fashion Agent, Body Measurement & Virtual Try-On</h1>
        <p>
          Upload your photo to get precise body measurements and try on clothes virtually
        </p>
      </Header>
      
      {loading ? (
        <LoadingSpinner message="Analyzing your image with AI..." />
      ) : (
        <ImageUploader onImageSelected={handleImageSelected} />
      )}
    </HomeContainer>
  );
};

export default HomePage;